import { styled } from 'styled-components';
import ArrowUp from '@/shared/assets/arrow-circle-up.svg';
import { Button } from '@/shared/ui/form/button';
import CarretRight from '@/shared/assets/caret-right.svg';
import { Image } from '@/shared/ui/image';
import Clock from '@/shared/assets/clock.svg';

const Wrapper = styled.div`
  display: flex;
  width: 460px;
  max-height: 720px;
  min-height: 660px;
  padding: 18px;
  flex-direction: column;
  gap: 3px;
  text-align: center;
  background: #131315;
  box-shadow: 0px 0px 250px 50px #131315;
  border-radius: 12px;
  border: 1px solid #131315;
  position: relative;
  ${({ $isSticky }) =>
    $isSticky &&
    `
padding-bottom:0;
`}
  ${({ $isFiat }) =>
    $isFiat &&
    `
gap:0; 
`}  

${({ $isFiatWithdraw }) =>
    $isFiatWithdraw &&
    `
  justify-content: flex-start;
    padding-bottom: 24px;

  `}

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: none;
    max-height: fit-content;
  }
`;

const ArrowUpIcon = styled(ArrowUp)`
  transform: rotate(180deg);

  path {
    fill: ${({ $active }) => ($active ? '#fff' : '#AFAFAF')};
  }
`;

const ClockIcon = styled(Clock)`
  path {
    fill: ${({ $active }) => ($active ? '#fff' : '#AFAFAF')};
  }
`;

const ArrowBottomIcon = styled(ArrowUpIcon)`
  transform: rotate(360deg);
`;

const WalletButton = styled(Button)`
  border-radius: 8px;
  gap: 4px;
  cursor: pointer;

  @media (max-width: 768px) {
    gap: 0px;
    height: 40px;
  }
`;

export { ArrowBottomIcon, ArrowUpIcon, ClockIcon, WalletButton, Wrapper };
